import happyMonster from '../../../assets/icons/npsEmoji/MSmile.svg'
import sadMonster from '../../../assets/icons/npsEmoji/MSad.svg'
import neutralMonster from '../../../assets/icons/npsEmoji/MNeutral.svg'
import HeartEyesMonster from '../../../assets/icons/npsEmoji/MLove.svg'
import angryMonster from '../../../assets/icons/npsEmoji/MAngry.svg'

import angry from '../../../assets/icons/npsEmoji/FAngry.svg'
import dislike from '../../../assets/icons/npsEmoji/FSad.svg'
import neutral from '../../../assets/icons/npsEmoji/FNeutral.svg'
import like from '../../../assets/icons/npsEmoji/FSmile.svg'
import love from '../../../assets/icons/npsEmoji/FLove.svg'

import outlinedAngry from '../../../assets/icons/npsEmoji/OAngry.svg'
import outlinedDislike from '../../../assets/icons/npsEmoji/OSad.svg'
import outlinedNeutral from '../../../assets/icons/npsEmoji/ONeutral.svg'
import outlinedLike from '../../../assets/icons/npsEmoji/OSmile.svg'
import outlinedLove from '../../../assets/icons/npsEmoji/OLove.svg'

import flatAngry from '../../../assets/icons/npsEmoji/FLAngry.svg'
import flatDislike from '../../../assets/icons/npsEmoji/FLSad.svg'
import flatNeutral from '../../../assets/icons/npsEmoji/FLNeutral.svg'
import flatLike from '../../../assets/icons/npsEmoji/FLSmile.svg'
import flatLove from '../../../assets/icons/npsEmoji/FLLove.svg'

import { getRawMessage } from '../../../locale'

export const monsterOptions = [
  {
    value: '1',
    label: angryMonster,
    name: getRawMessage(
      'pages.formMaker.section.availableFields.embeded.options.hate'
    ),
  },
  {
    value: '2',
    label: sadMonster,
    name: getRawMessage(
      'pages.formMaker.section.availableFields.embeded.options.dislike'
    ),
  },
  {
    value: '3',
    label: neutralMonster,
    name: getRawMessage(
      'pages.formMaker.section.availableFields.embeded.options.neutral'
    ),
  },
  {
    value: '4',
    label: happyMonster,
    name: getRawMessage(
      'pages.formMaker.section.availableFields.embeded.options.like'
    ),
  },
  {
    value: '5',
    label: HeartEyesMonster,
    name: getRawMessage(
      'pages.formMaker.section.availableFields.embeded.options.love'
    ),
  },
]

export const outlinedOptions = [
  {
    value: '1',
    label: outlinedAngry,
    name: getRawMessage(
      'pages.formMaker.section.availableFields.embeded.options.hate'
    ),
  },
  {
    value: '2',
    label: outlinedDislike,
    name: getRawMessage(
      'pages.formMaker.section.availableFields.embeded.options.dislike'
    ),
  },
  {
    value: '3',
    label: outlinedNeutral,
    name: getRawMessage(
      'pages.formMaker.section.availableFields.embeded.options.neutral'
    ),
  },
  {
    value: '4',
    label: outlinedLike,
    name: getRawMessage(
      'pages.formMaker.section.availableFields.embeded.options.like'
    ),
  },
  {
    value: '5',
    label: outlinedLove,
    name: getRawMessage(
      'pages.formMaker.section.availableFields.embeded.options.love'
    ),
  },
]

export const funnyFaceOptions = [
  {
    value: '1',
    label: angry,
    name: getRawMessage(
      'pages.formMaker.section.availableFields.embeded.options.hate'
    ),
  },
  {
    value: '2',
    label: dislike,
    name: getRawMessage(
      'pages.formMaker.section.availableFields.embeded.options.dislike'
    ),
  },
  {
    value: '3',
    label: neutral,
    name: getRawMessage(
      'pages.formMaker.section.availableFields.embeded.options.neutral'
    ),
  },
  {
    value: '4',
    label: like,
    name: getRawMessage(
      'pages.formMaker.section.availableFields.embeded.options.like'
    ),
  },
  {
    value: '5',
    label: love,
    name: getRawMessage(
      'pages.formMaker.section.availableFields.embeded.options.love'
    ),
  },
]

export const flatFaceOptions = [
  {
    value: '1',
    label: flatAngry,
    name: getRawMessage(
      'pages.formMaker.section.availableFields.embeded.options.hate'
    ),
  },
  {
    value: '2',
    label: flatDislike,
    name: getRawMessage(
      'pages.formMaker.section.availableFields.embeded.options.dislike'
    ),
  },
  {
    value: '3',
    label: flatNeutral,
    name: getRawMessage(
      'pages.formMaker.section.availableFields.embeded.options.neutral'
    ),
  },
  {
    value: '4',
    label: flatLike,
    name: getRawMessage(
      'pages.formMaker.section.availableFields.embeded.options.like'
    ),
  },
  {
    value: '5',
    label: flatLove,
    name: getRawMessage(
      'pages.formMaker.section.availableFields.embeded.options.love'
    ),
  },
]
